import ShowResourceAnnotation from "@/modules/reader/annotations/builders/showResource/ShowResourceAnnotation"
import AbstractBuilder from "@/modules/reader/annotations/builders/AbstractBuilder";

class ShowResourceBuilder {

    constructor() {

    }

    static get Builder() {
        class Builder extends AbstractBuilder {

            build() {
                return new ShowResourceAnnotation(this);
            }
        }
        return Builder;
    }
}

export default ShowResourceBuilder